import {Injectable} from '@angular/core';
import {ApibaseService} from './apibase.service';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ParametrosVo} from '~model/vo/parametros-vo';

@Injectable()
export class ConfigParametrosService extends ApibaseService {

  prefixoUrl = 'controlTower';
  urlFunction = 'configuracao/parametros';

  createParametros(): Observable<ParametrosVo> {
    return super.post<ParametrosVo>({
        objEnvio: {
          alertaDeProximidade: 0,
          alertaMinimo: 0,
          alterarProximaVisita: false,
          estrategia: '',
          incluirAuto: false,
          incluirNovosAuto: false,
          limiteAtraso: 0,
          removerAuto: false,
          utilizaCD: false,
        },
      }
    ).pipe(this.defaultCatch());
  }

  getParametros(): Observable<ParametrosVo> {
    return super.get<ParametrosVo>().pipe(
      catchError(err => {
        if (err.status === 404) {
          this.createParametros().subscribe();
        }
        return of<ParametrosVo>();
      })
    );
  }

  updateParametros(parameters: ParametrosVo): Observable<ParametrosVo> {
    return super.put<ParametrosVo>('', {objEnvio: parameters}).pipe(this.defaultCatch());
  }
}
